import * as React from 'react';

import {labelComponent} from '../util/media';
import {InstrumentedCenteredWaveLoader as Loader} from './../components/utility/InstrumentedLoader';
import {type MediaCardProps} from './MediaCard';
import MessageMediaNotFound from './MessageMediaNotFound';
import {SingleRunLink} from './MultiRunWorkspace/SingleRunMode';
import HtmlViewer from './Panel2/HtmlViewer';
import {useGetTrackingCallbacks} from './PanelMediaBrowser/MediaBrowserPanelTileTrackingContext';

const HtmlCard = (props: MediaCardProps) => {
  const {
    run,
    globalStep,
    mediaKey,
    mediaIndex,
    runSignature,
    height,
    tileMedia,
    loading,
    customRunName,
    tileMediaSpec,
    getMediaTracking,
  } = props;

  const titleLink = (
    <SingleRunLink
      {...runSignature}
      linkText={customRunName ?? run.displayName}
    />
  );

  const {trackSuccess, trackError} = useGetTrackingCallbacks(
    tileMedia,
    tileMediaSpec,
    getMediaTracking
  );

  return loading ? (
    <Loader name="panel-content-loader" size="small" />
  ) : (
    <HtmlViewer
      headerElements={labelComponent(props, tileMedia?.step, titleLink)}
      notFoundElements={
        <MessageMediaNotFound
          mediaIndex={mediaIndex}
          mediaKey={mediaKey}
          stepIndex={globalStep}
          mediaType="html"
        />
      }
      htmlNotFound={tileMedia == null}
      height={height}
      // We can't trust this raw content so no objectURL here!
      src={tileMedia?.directURL}
      trackSuccess={trackSuccess}
      trackError={trackError}
    />
  );
};

export default HtmlCard;
